import { Optional } from "@/globalTypes";

export type Manufacture = {
  id: Number;
  name: String;
};

export type ManufacturersResponse = {
  manufacturers: Array<Manufacture>;
};

export type Serie = {
  rangeId: Number;
  rangeName: String;
  yearFrom: String;
  yearTo: String;
};

export type SerieResponse = {
  series: Array<Serie>;
};

export type Car = {
  vin?: Optional<String>;
  typeId: Number;
  makeName: String;
  rangeName: String;
  typeName: String;
  yearFrom: String;
  yearTo: String;
  ccm: String;
  construction: String;
  engine: String;
  kw: String;
  fuel: String;
};

export type OtherCar = {
  typeId: Number;
  name: String;
};

export type CarType = {
  typeId: Number;
  typeName: String;
  kw: String;
  fuel: String;
  ccm: String;
  engine: String;
  construction: String;
  yearFrom: String;
  yearTo: String;
};

export type CarTypeResponse = {
  types: Array<CarType>;
};

export type CarByVin = {
  manufacturer: { MakeName: String };
  serie: Serie;
  type: CarType;
};

export type CarsByVin = {
  cars: Array<CarByVin>;
};

export type SelectedCarCookie = {
  vin: String;
  typeId: Number;
};

export function mapCarByVinToCar(car: CarByVin, vin?: String | undefined): Car {
  return {
    vin: vin,
    typeId: car.type.typeId,
    makeName: car.manufacturer.MakeName,
    rangeName: car.serie.rangeName,
    typeName: car.type.typeName,
    yearFrom: car.type.yearFrom,
    yearTo: car.type.yearTo,
    ccm: car.type.ccm,
    construction: car.type.construction,
    engine: car.type.engine,
    kw: car.type.kw,
    fuel: car.type.fuel,
  };
}
